import React from 'react';

export const LinkElement = (props) => {
  const { attributes, children, element, style: styleProp = {} } = props;
  const { url, children: childrenArray } = element;

  let style = styleProp;

  // Propagate text color to link element
  if (childrenArray.length > 0) {
    const firstChild = childrenArray[0];
    const { color } = firstChild;
    if (color) {
      style = { ...style, color };
    }
  }

  return (
    <a
      {...attributes}
      style={style}
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
};
